import _ShadeGenerator from "shade-generator";
import { Shade } from "shade-generator/dist/models";
// Vite 8 / Rollup 4 changed CJS default interop: unwrap .default if needed
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ShadeGenerator: typeof _ShadeGenerator = (_ShadeGenerator as any).default ?? _ShadeGenerator;
export type ColorPalette = {
  colorPrimary: string;

  colorLighter?: string;
  colorLight?: string;
  colorDark?: string;
  colorDarker?: string;

  colorSecondary: string;

  colorSecondaryLighter?: string;
  colorSecondaryLight?: string;
  colorSecondaryDark?: string;
  colorSecondaryDarker?: string;

  colorInfo?: string;
  colorSuccess?: string;
  colorWarning?: string;
  colorError?: string;

  colorAccentDark?: string;
  colorAccentLight?: string;
  colorAccentSemiLight?: string;
  colorAccentExtraLight?: string;
};
export type SkinConfig = {
  colorPalette: ColorPalette;
  sizeConfig: {
    fontSize: number;
    borderRadius: number;
    fontFamily: string;
  };
};

export const getCSSByPalette = (
  {
    //colorLighter,
    colorPrimary,
    //colorLight,
    colorDark,
    colorDarker,
    colorSecondary,
    //colorSecondaryLighter,
    //colorSecondaryLight,
    colorSecondaryDark,
    colorSecondaryDarker,

    colorAccentDark,
    colorAccentLight,
    colorAccentSemiLight,
    colorAccentExtraLight,
  }: ColorPalette,
  fontFamily: string,
  fontSize: string
) => {
  return `
            :root {
            --main-color-lighter: ${colorPrimary}2b;
            --main-color-light: ${colorPrimary}a3;
            --main-color: ${colorPrimary};
            --main-color-dark:  ${colorDark};
            --main-color-darker:  ${colorDarker};

            --secondary-color-lighter: ${colorSecondary}2b;
            --secondary-color-light: ${colorSecondary}75;
            --secondary-color: ${colorSecondary};
            --secondary-color-dark:  ${colorSecondaryDark};
            --secondary-color-darker:  ${colorSecondaryDarker};

            --main-font: ${fontFamily};
            --text: ${fontSize}px;

            --accent-xtralight: ${colorAccentExtraLight ?? "#EFF6FF"};
            --accent-semilight: ${colorAccentSemiLight ?? "#DDEAFB"};
            --accent-light: ${colorAccentLight ?? "#89ABDB"};
            --accent-dark: ${colorAccentDark ?? "#3B76BA"};
        }`;
};

export const getPalette = (
  colorPrimary: string,
  colorSecondary: string,
  colorAccentDark?: string,
  colorAccentLight?: string,
  colorAccentSemiLight?: string,
  colorAccentExtraLight?: string
) => {
  const palette: ColorPalette = {
    colorPrimary,
    colorLighter: getColorShade(colorPrimary, "40"),
    colorLight: getColorShade(colorPrimary, "70"),
    colorDark: getColorShade(colorPrimary, "500"),
    colorDarker: getColorShade(colorPrimary, "700"),
    colorSecondary,
    colorSecondaryLighter: getColorShade(colorSecondary, "40"),
    colorSecondaryLight: getColorShade(colorSecondary, "70"),
    colorSecondaryDark: getColorShade(colorSecondary, "500"),
    colorSecondaryDarker: getColorShade(colorSecondary, "700"),

    colorAccentDark,
    colorAccentLight,
    colorAccentSemiLight,
    colorAccentExtraLight,
  };
  return palette;
};

const getColorShade = (color: string, shade: Shade) => {
  return ShadeGenerator.hue(color).shade(shade).hex();
};

export const getSkinConfigByUnivers: (brand: string) => SkinConfig = (
  brand: string
) => {
  switch (brand.toLowerCase()) {
    case "acv":
      return {
        colorPalette: getPalette(
          "#000000",
          "#2c2e34",
          "#AD0600",
          "#000000",
          "#F3F3F3",
          "#F3F3F3"
        ),
        sizeConfig: {
          fontSize: 13,
          borderRadius: 2,
          fontFamily: "Figtree",
        },
      };

    case "ygnis":
      return {
        colorPalette: getPalette(
          "#00B8A8",
          "#2c2e34",
          "#FFB000",
          "#00B8A8",
          "#F1F1F1",
          "#F1F1F1"
        ),
        sizeConfig: {
          fontSize: 13,
          borderRadius: 2,
          fontFamily: "Montserrat",
        },
      };

    case "hamworthy":
      return {
        colorPalette: getPalette(
          "#0054A0",
          "#2c2e34",
          "#ED8000",
          "#0054A0",
          "#F3F3F3",
          "#F3F3F3"
        ),
        sizeConfig: {
          fontSize: 13,
          borderRadius: 2,
          fontFamily: "Lato",
        },
      };

    case "ideal":
      return {
        colorPalette: getPalette(
          "#19223D",
          "#2c2e34",
          "#95C11F",
          "#474E64",
          "#A3A7B1",
          "#E8E9EC"
        ),
        sizeConfig: {
          fontSize: 13,
          borderRadius: 2,
          fontFamily: "Montserrat",
        },
      };
    case "atlantic":
      return {
        colorPalette: getPalette(
          // "#4F8BD1",
          // "#679480",
          // "#3B76BA",
          // "#89ABDB",
          // "#DDEAFB",
          // "#EFF6FF"
          "#00A07A",
          "#000000",
          "#008879",
          "#45B384",
          "#C5E2D0",
          "#E3F1E8",
        ),
        sizeConfig: {
          fontSize: 12,
          borderRadius: 5,
          fontFamily: "poppins",
        },
      };
    default:
      return {
        colorPalette: getPalette(
          "#585858",
          "#679480",
          "#414141",
          "#A3A3A3",
          "#C5C5C5",
          "#DBDBDB"
        ),
        sizeConfig: {
          fontSize: 12,
          borderRadius: 5,
          fontFamily: "poppins",
        },
      };
  }
};

//export const getMainColorsByUnivers = (brand: string) => {
//    switch (brand.toLowerCase()) {
//        case 'atlantic':
//            return ['#934f9a', '#679480'];
//        case 'thermor':
//            return ['#e62814', '#2c2e34'];

//        default:
//            return ['#2c2e34', '#e62814'];
//    }

//};
